import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
export default {
    init() {
        UIkit.use(Icons);
    },
    notify(msg) {
        UIkit.notification({
            message: msg,
            status: 'warning',
            pos: 'top-right',
            timeout: 3500
        });
    },
    hideModal(element) {
        UIkit.modal(element).hide();
    }
}